import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconChevronUp({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="m3.666.343 1.666 2.286C5.744 3.194 5.352 4 4.666 4H1.334C.648 4 .256 3.194.668 2.629L2.334.343a.819.819 0 0 1 1.332 0z"/>
        </svg>
    );
}

export default IconChevronUp;
